export default __webpack_public_path__ + "static/media/login-logo.d73c0208.svg";